import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const success = await login(loginId, password);
      if (success) {
        navigate('/dashboard');
      } else {
        setError('Invalid credentials. Please check your login ID and password.');
      }
    } catch (error) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #E63946 0%, #1E3A8A 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1rem',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Animated background circles */}
      <div style={{
        position: 'absolute',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.1)',
        top: '-100px',
        right: '-100px',
        animation: 'pulse 4s ease-in-out infinite'
      }}></div>
      <div style={{
        position: 'absolute',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.1)',
        bottom: '-50px',
        left: '-50px',
        animation: 'pulse 3s ease-in-out infinite'
      }}></div>
      
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={5} xl={4}>
            <div className="modern-card" style={{ 
              padding: '0', 
              borderRadius: '20px',
              animation: 'scaleIn 0.5s ease',
              background: 'white'
            }}>
              <div className="gradient-card" style={{
                borderRadius: '20px 20px 0 0',
                padding: '2.5rem 2rem',
                textAlign: 'center',
                marginBottom: 0
              }}>
                <h3 style={{ 
                  fontSize: '2rem', 
                  fontWeight: '700',
                  marginBottom: '0.5rem',
                  textShadow: '0 2px 10px rgba(0,0,0,0.1)'
                }}>ATN Instruments</h3>
                <p style={{ opacity: 0.9, marginBottom: 0 }}>Dashboard Login</p>
              </div>
              
              <div style={{ padding: '2.5rem 2rem' }}>
                <h5 className="text-center mb-4" style={{ 
                  color: '#2d3748',
                  fontWeight: '600'
                }}>Welcome Back!</h5>
                
                {error && (
                  <Alert variant="danger" style={{
                    borderRadius: '12px',
                    border: 'none',
                    animation: 'shake 0.5s'
                  }}>
                    {error}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ 
                      fontWeight: '600',
                      color: '#4a5568'
                    }}>Login ID</Form.Label>
                    <Form.Control
                      className="modern-input"
                      type="text"
                      placeholder="Enter your login ID"
                      value={loginId}
                      onChange={(e) => setLoginId(e.target.value)}
                      required
                      style={{
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        padding: '0.75rem 1rem',
                        fontSize: '1rem'
                      }}
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-4">
                    <Form.Label style={{ 
                      fontWeight: '600',
                      color: '#4a5568'
                    }}>Password</Form.Label>
                    <Form.Control
                      className="modern-input"
                      type="password"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      style={{
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        padding: '0.75rem 1rem',
                        fontSize: '1rem'
                      }}
                    />
                  </Form.Group>
                  
                  <Button
                    className="btn-gradient w-100"
                    type="submit"
                    disabled={loading}
                    style={{
                      padding: '0.875rem',
                      fontSize: '1rem',
                      fontWeight: '600',
                      borderRadius: '12px',
                      border: 'none',
                      background: 'linear-gradient(135deg, #E63946 0%, #DC2626 100%)',
                      boxShadow: '0 4px 12px rgba(230, 57, 70, 0.4)'
                    }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Signing in...
                      </>
                    ) : (
                      'Sign In'
                    )}
                  </Button>
                </Form>
                
                <div className="mt-4 text-center">
                  <small style={{ color: '#718096' }}>
                    <strong>Demo Credentials:</strong><br />
                    Admin: admin / password<br />
                    Customer: customer1 / password
                  </small>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;